<template>
	<div>
		<div v-if="isLoading" class="d-flex align-items-center justify-content-center">
			<grid-loader :loading="isLoading" :color="spinner.color" :size="spinner.size"></grid-loader>
		</div>
		<div v-else>
			<div class="row update-profile justify-content-center justify-content-sm-start">
				<div v-if="!disableImageUpload" class="col-md-3 col-6 mb-4 text-center">
					<img :src="imageSrc" alt="Logo" class="img-thumbnail mb-4" />
					<vue-core-image-upload
							:class="['btn', 'btn-primary']"
							extensions="png,gif,jpeg,jpg"
							crop="server"
							crop-ratio="1:1"
							@imageuploaded="imageUploaded"
							:max-file-size="5242880"
							:url="uploadRoute"
							:headers="{ 'X-CSRF-TOKEN': csrfToken }"
					>
					</vue-core-image-upload>
				</div>
				<div :class="disableUpload">
					<div class="form-group">
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label for="country_address">{{'Country' | trans}}</label>
									<select-group v-model="address.C_Country_Address_ID" :list="countriesAll"
									              :fieldValue="'C_Country_ID'" :fieldText="'Name'" id="country_address"
									              :className="status($v.address.C_Country_Address_ID)"
									              :groupClassName="{'form-group--error': $v.address.C_Country_Address_ID.$error}">
										<option value="">-- {{'Country' | trans}} --</option>
										<template slot="after">
											<ul class="invalid-feedback list-unstyled" v-if="$v.address.C_Country_Address_ID.$error">
												<li v-if="!$v.address.C_Country_Address_ID.required">
													{{'This field is required' | trans}}
												</li>
											</ul>
										</template>
									</select-group>
									<form-errors :field-name="'address.C_Country_Address_ID'" />
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group">
									<label for="C_Region_ID">{{'Region' | trans}}</label>
									<select-group v-model="address.C_Region_ID" :list="regions" :fieldValue="'C_Region_ID'"
									              :fieldText="'Name'" :isPending="regionIsPending"
									              id="C_Region_ID" name="C_Region_ID"
									              :className="status($v.address.C_Region_ID)"
									              :groupClassName="{ 'form-group--error': $v.address.C_Region_ID.$error}">
										<option selected value="">-- {{'Region' | trans}} --</option>
										<template slot="after">
											<ul class="invalid-feedback list-unstyled" v-if="$v.address.C_Region_ID.$error">
												<li v-if="!$v.address.C_Region_ID.required">
													{{'This field is required' | trans}}
												</li>
											</ul>
										</template>
									</select-group>
									<form-errors :field-name="'address.C_Region_ID'" />
								</div>
							</div>
						</div>
					</div>
					<div class="form-group">
						<div class="row">
							<div class="col-md-6" :class="{ 'form-group--error': $v.address.Street.$error}">
								<label for="street">{{'Street' | trans}}</label>
								<input type="text" class="form-control" v-model="address.Street" id="street"
								       :class="status($v.address.Street)" placeholder="Str.">
								<ul class="invalid-feedback list-unstyled" v-if="$v.address.Street.$error">
									<li v-if="!$v.address.Street.required">
										{{'This field is required' | trans}}
									</li>
								</ul>
								<form-errors :field-name="'address.Street'" />
							</div>
							<div class="col-md-3">
								<label for="buildingNo">{{'Building' | trans}}</label>
								<input type="text" class="form-control" v-model="address.BuildingNo" id="buildingNo"
								       :class="status($v.address.BuildingNo)" placeholder="#">
							</div>
							<div class="col-md-3">
								<label for="apartment">{{'Apartment' | trans}}</label>
								<input type="text" class="form-control" v-model="address.Apartment" id="apartment"
								       :class="status($v.address.Apartment)" placeholder="#">
							</div>
						</div>
					</div>
					
					<div class="form-group">
						<div class="row">
							<div class="col-md-6" :class="{ 'form-group--error': $v.address.ZIP.$error}">
								<label for="zip">{{'ZIP' | trans}}</label>
								<input type="text" class="form-control" v-model="address.ZIP" id="zip"
								       :class="status($v.address.ZIP)" placeholder="12345">
								<ul class="invalid-feedback list-unstyled" v-if="$v.address.ZIP.$error">
									<li v-if="!$v.address.ZIP.required">
										{{'This field is required' | trans}}
									</li>
								</ul>
								<form-errors :field-name="'address.ZIP'" />
							</div>
							<div class="col-md-6" :class="{ 'form-group--error': $v.address.City.$error}">
								<label for="city">{{'City' | trans}}</label>
								<input type="text" class="form-control" v-model="address.City" id="city"
								       :class="status($v.address.City)" placeholder="New York">
								<ul class="invalid-feedback list-unstyled" v-if="$v.address.City.$error">
									<li v-if="!$v.address.City.required">
										{{'This field is required' | trans}}
									</li>
								</ul>
								<form-errors :field-name="'address.City'" />
							</div>
						</div>
					</div>
					
					<div class="form-group">
						<spinner-button :className="'btn btn-danger'" @click="updateProfile" :is-pending="isPending">
							{{'cauri.Complete' | trans}}
						</spinner-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex'
	/**
	 * Image uploader
	 */
	import VueCoreImageUpload from 'vue-core-image-upload';
	import GridLoader from 'vue-spinner/src/GridLoader.vue';

	const { required, email } = require('vuelidate/lib/validators');
	import { validationMixin } from 'vuelidate';

    export default {
        props: ['route', 'landingRoute', 'clientInfo', 'clientAddress', 'uploadRoute',
	        'disableImageUpload'],
	    mixin: {
		    validationMixin
	    },
	    components: {
		    'vue-core-image-upload': VueCoreImageUpload,
		    'GridLoader': GridLoader
	    },
        data() {
            return {
	            isLoading: false,
	            imageSrc: '',
	            isPending: false,
	            regionIsPending: false,
	            regions: [],
	            phonePlaceHolder: '0012345678901',
	            tmpRegionId: '',
	            profile: {},
	            address: {
		            C_BPartner_ID: '',
		            C_Country_Address_ID: '',
		            C_Region_ID: '',
		            City: '',
		            Street: '',
		            BuildingNo: '',
		            Apartment: '',
		            ZIP: ''
	            }
            };
        },
	    computed: {
		    ...mapGetters('Application', ['countries', 'countriesAll']),
        	disableUpload() {
        		return (this.disableImageUpload? "col-12": "col-md-7");
	        }
	    },
	    mounted() {
        	if(this.$props.clientInfo && this.$props.clientAddress) {
		        this.address.C_BPartner_ID = this.$props.clientInfo.C_BPartner_ID;
		        this.address.ZIP = this.$props.clientAddress.Postal;
		        this.address.City = this.$props.clientAddress.City;
		        this.address.Street = this.$props.clientAddress.Address1;
		        this.address.BuildingNo = this.$props.clientAddress.Address2;
		        this.address.Apartment = this.$props.clientAddress.Address3;
		        this.address.C_Country_Address_ID = this.$props.clientAddress.C_Country_ID;
		        this.tmpRegionId = this.$props.clientAddress.C_Region_ID;
		        this.imageSrc = 'data:image/png;base64, ' + this.$props.clientInfo.BinaryData;
	        }

		    this.EventBus.$on('showProfileForm', (route) => {
			    this.$v.$reset();
			    this.isLoading = true;
			    this.loadProfile(route);
		    });

		    this.EventBus.$on('hideProfileForm', () => {
			    this.$v.$reset();
			    this.address.C_BPartner_ID = "";
			    this.address.ZIP = "";
			    this.address.City = "";
			    this.address.Street = "";
			    this.address.BuildingNo = "";
			    this.address.Apartment = "";
			    this.address.C_Country_Address_ID = "";
			    this.address.C_Region_ID = "";
			    this.imageSrc = 'data:image/png;base64, ';
		    });
	    },
        methods: {
	        async loadProfile(route) {
		        let result = await axios.get(route, {})
			        .finally(() => { this.isLoading = false; });
		        if(result.data) {
			        this.address.C_BPartner_ID = result.data.clientInfo.C_BPartner_ID;
					if(result.data.clientAddress) {
						this.address.ZIP = result.data.clientAddress.Postal;
						this.address.City = result.data.clientAddress.City;
						this.address.Street = result.data.clientAddress.Address1;
						this.address.BuildingNo = result.data.clientAddress.Address2;
						this.address.Apartment = result.data.clientAddress.Address3;
						this.address.C_Country_Address_ID = result.data.clientAddress.C_Country_ID;
						this.tmpRegionId = result.data.clientAddress.C_Region_ID;
					}
		        }
		        this.$v.$touch();
	        },
            async updateProfile() {
	            this.$v.$touch();
	            if (!this.$v.$invalid) {
		            this.isPending = true;
		            this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
		            var post = {};
		            post.address = this.address;
		            await axios.post(window.updateProfile, post)
			            .then(() => {
				            this.EventBus.$emit('event-success', Lang.get('Success'));
				            if (this.landingRoute) {
					            setTimeout(() => window.location.href = this.landingRoute, this.beforeRedirectTimeOut);
				            } else {
					            this.$emit('updated');
				            }
			            })
			            .finally(() => this.isPending = false);
	            }
            },
            imageUploaded(res) {
                if (res.src) {
                    this.imageSrc = res.src;
                }
            },
	        async getRegions(countryId) {
		        this.regions = [];
		        if(countryId) {
			        this.regionIsPending = true;
			        this.address.C_Region_ID = '';
			        let result = await axios.get(`/countries/${countryId}/regions`)
				        .finally(() => this.regionIsPending = false);
			        this.regions = result.data;
			        if (this.tmpRegionId) {
				        this.address.C_Region_ID = this.tmpRegionId;
				        this.tmpRegionId = '';
			        }
		        }
	        }
        },
	    watch: {
		    'address.C_Country_Address_ID': function(countryId) {
			    this.getRegions(countryId);
		    }
	    },
	    validations() {
		    let v = {
			    address: {
				    C_Country_Address_ID: {required},
				    C_Region_ID: {},
				    City: {required},
				    Street: {required},
				    BuildingNo: {},
				    Apartment: {},
				    ZIP: {}
			    }
		    };

		    if(this.regions.length > 0) {
		    	v.address.C_Region_ID = { required };
		    }

		    return v;
	    }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/update-profile.vue